import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { CACHE_KEY_OTC } from 'src/app/hooks/data/_keys';
import { useBffClient } from 'src/app/hooks/data/useBffClient';
import { useUser } from 'src/app/hooks/data/user';
import useAuth from 'src/app/hooks/useAuth';
import type { OTCCategoryV2, ReactQueryOptions } from 'src/app/types';

export const useOTCMedCategoriesV2 = (options?: Partial<ReactQueryOptions>) => {
  const authClient = useBffClient();
  const { loggedInUser } = useAuth();
  const { data: user } = useUser(loggedInUser ? loggedInUser.uuid : '', Boolean(loggedInUser));
  const accountId = user?.accountId ?? '';

  return useQuery<OTCCategoryV2[], AxiosError>(
    [CACHE_KEY_OTC, 'otcsV2', accountId],
    () => authClient.get(`/v2/otcs/${accountId}`).then(resp => resp.data),
    {
      refetchOnWindowFocus: false,
      enabled: (options?.enabled === undefined || options?.enabled) && !!accountId,
    }
  );
};

export const useOTCMedCheckoutAddonsV2 = (options?: Partial<ReactQueryOptions>) => {
  const authClient = useBffClient();
  const { loggedInUser } = useAuth();
  const { data: user } = useUser(loggedInUser ? loggedInUser.uuid : '', Boolean(loggedInUser));
  const accountId = user?.accountId ?? '';

  return useQuery<OTCCategoryV2[], AxiosError>(
    [CACHE_KEY_OTC, 'personalizedV2', accountId],
    () => authClient.get(`/v2/otcs/personalized/${accountId}`).then(resp => resp.data),
    {
      refetchOnWindowFocus: false,
      enabled: (options?.enabled === undefined || options?.enabled) && !!accountId,
    }
  );
};
